import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "col-md-8" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_3 = { class: "activityAdditionalInfo" }
const _hoisted_4 = {
  key: 0,
  class: "col-md-3"
}
const _hoisted_5 = {
  key: 1,
  class: "col-md-3"
}
const _hoisted_6 = {
  key: 2,
  class: "col-md-3"
}
const _hoisted_7 = { class: "list-unstyled" }
const _hoisted_8 = {
  key: 0,
  class: "activityMetaLabel"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = { key: 1 }
const _hoisted_11 = {
  key: 2,
  class: "activityMetaLabel"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_13 = { class: "col-md-1 text-right pr-0" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("button", { class: "btn desktop-only" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-chevron-right" })
], -1)
const _hoisted_15 = { class: "btn mobile-only w-100 text-center" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-chevron-down" }, null, -1)
const _hoisted_17 = [
  _hoisted_16
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "row activity activity-non-featured",
    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.emitSelectedActivity()))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("strong", null, _toDisplayString(_ctx.calendarContent.displayName), 1),
      _hoisted_2,
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.calendarContent.locationName), 1)
    ]),
    (_ctx.activityDaySchedule.isAllDayEvent)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, "All Day"))
      : _createCommentVNode("", true),
    (_ctx.activityDaySchedule.toBeDetermined)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, "TBD"))
      : _createCommentVNode("", true),
    (!_ctx.activityDaySchedule.isAllDayEvent && !_ctx.activityDaySchedule.toBeDetermined)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("ul", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activityDaySchedule.schedules, (schedule) => {
              return (_openBlock(), _createElementBlock("li", {
                key: schedule.sortKey
              }, [
                (schedule.prependText)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_8, [
                      _createTextVNode(_toDisplayString(schedule.prependText), 1),
                      _hoisted_9
                    ]))
                  : _createCommentVNode("", true),
                _createTextVNode(" " + _toDisplayString(schedule.displayStart) + " ", 1),
                (schedule.displayEnd)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_10, "— " + _toDisplayString(schedule.displayEnd), 1))
                  : _createCommentVNode("", true),
                _createTextVNode(),
                (schedule.appendText)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
                      _hoisted_12,
                      _createTextVNode(_toDisplayString(schedule.appendText), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_13, [
      _hoisted_14,
      _createElementVNode("button", _hoisted_15, [
        _createElementVNode("a", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.emitSelectedActivity()))
        }, _hoisted_17)
      ])
    ])
  ]))
}